import React, { useState, useEffect } from 'react';
import { Form, Field, FieldWrapper, FormElement } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import SubHeader from '../components/SubHeader';
import { FormComboBox, FormSubTitle,FormSubTitleDesp,FormTitle, TermsFormCheckboxNoErrMsgDisplay } from '../validation/Form-Components';
import { certBoardResoValidator} from '../validation/Validators';
import TooltipTemplate from '../components/TooltipTemplate';
import { Tooltip } from '@progress/kendo-react-tooltip';
import config from '../appconfig/config.json';
import { useHistory } from "react-router-dom";
import CusProgressBar from '../components/CusProgressBar';
import delegateData from '../data/delegationdetailsdata.json';
import WtBgChkbox from '../components/WtBgChkbox';
import service from '../services/ApiService.js';
import Loading from '../components/Loading';
import conOfSigns from '../data/condofsign.json';
import helper from '../factory/Helper';
import designations from '../data/position.json';
import uploadConfig from '../data/uploaddetailsdata.json';
import storage from '../factory/StorageFactory';
import CusToast from '../components/CusToast';
 

let holders=[];

const NSDelegationDetails = (props) => {
    let timer;
    const detailsType='9';
    const seq0='0', seq1='1',seq2='2',seq3='3';
    const item = { bgcolor: "#389A6E", completed: 60 };
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);
 
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [response,setResponse] = useState();

    const [certPersons, setCertPersons]  = useState([]);
    const [authPersons, setAuthPersons] = useState([]);
    const [boardResoClare, setBoardResoClare]  = useState({
        AuthPerSeq0:false,
        AuthPerSeq1:false,
        AuthPerSeq2:false,
        AuthPerSeq3:false
    })
 

    const [nsDeleDtls, setNSDeleDtls] = useState({
        SignConditionAP:'',
        BoadResoClare:false
    });

    useEffect(() => {
        
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

        window.scrollTo(0,0);
         
        getData();
        return () => clearTimeout(timer);
    }, []);
 
    const getData = () => {
        service.get().then( res => {
          
            if(res.data.isSucess){
                createHolders(res.data.model.fields.request);
                setResponse(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request);
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
       
            setIsLoading(false);
            showErrMsg('Error: Get data failed.')
        })
    }

    const getCompName = () => {
        return '('+ response.CompDtls.CompName+')';
    }

    const isFirstUser = () => {
        if(response.ApplicantsDtlsMyInfo.isFirstUser === 'true') {
            return true;
        }
        else {
            return false;
        }
    }
    const bindFormData = (data) => {
        try {          
            bindConOfSigns(data);   //cond of sign dropdown
            if(data.BoardResolutions){
                if(data.BoardResolutions.CertifyPerson && data.BoardResolutions.CertifyPerson !== null){ //not first time
                    bindCertPersons(data);
                }
                else {
                    bindCertPerFromApplicantDtls(data);
                }
            }
            else {
                bindCertPerFromApplicantDtls(data);
            }

            if(data.ApptAuthPerson && data.ApptAuthPerson !==null) {
                bindApptAuthPersons(data);
            }
            else {
                bindApptPersonsFromApplicantDtls(data);
            } 

       
            setIsLoading(false);
         
        } catch(ex){
           
        }
    }

    const bindCertPersons = (data) => {
        let certPersonsArray = [];
        if(data.BoardResolutions.CertifyPerson && data.BoardResolutions.CertifyPerson !== null) {
            if(data.BoardResolutions.CertifyPerson.length === undefined) {   //object
                certPersonsArray.push({
                    Name:data.BoardResolutions.CertifyPerson.Name,
                    IDNum:data.BoardResolutions.CertifyPerson.IDNum,
                    ApplicantSeq:data.BoardResolutions.CertifyPerson.ApplicantSeq,
                    Designation:data.BoardResolutions.CertifyPerson.Designation,
                    SelectedValue: data.BoardResolutions.CertifyPerson.SelectedValue === 'false'? false:true
                })
            }
            else {
                for(let i in data.BoardResolutions.CertifyPerson) {
                    certPersonsArray.push({
                        Name: data.BoardResolutions.CertifyPerson[i].Name,
                        IDNum: data.BoardResolutions.CertifyPerson[i].IDNum,
                        ApplicantSeq: data.BoardResolutions.CertifyPerson[i].ApplicantSeq,
                        Designation: data.BoardResolutions.CertifyPerson[i].Designation,
                        SelectedValue:data.BoardResolutions.CertifyPerson[i].SelectedValue === 'false'? false:true
                    })
                }
            }
        }
        setCertPersons(certPersonsArray);
    }

    const bindApptAuthPersons = (data) =>{
        let apptAuthPersonsArray = [];
        if(data.ApptAuthPerson.length === undefined) {  //object   
            //not reformatting straight away bind bcuz it is disable fileds
            apptAuthPersonsArray.push(data.ApptAuthPerson);  
        }  
        else {
            apptAuthPersonsArray = data.ApptAuthPerson;
        }
   
        setAuthPersons(apptAuthPersonsArray)
    }

    const bindCertPerFromApplicantDtls = (data) => {
        let certPersonsArray = [];
        if(data.ApplicantDtls.length === undefined) {  //check object  
            certPersonsArray.push({
                Name: data.ApplicantDtls.Name,
                IDNum: data.ApplicantDtls.IDNum,
                ApplicantSeq: data.ApplicantDtls.ApplicantSeq,
                Designation: helper.getDesignationbyIDNum(data.ApplicantDtls.IDNum,holders),
                SelectedValue: true
            })
        }
        else { //array
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].ApplicantSeq !== seq0) {
                    if(data.ApplicantDtls[i].Authorised === undefined || data.ApplicantDtls[i].Authorised === 'true'){
                        certPersonsArray.push({
                            Name: data.ApplicantDtls[i].Name,
                            IDNum: data.ApplicantDtls[i].IDNum,
                            ApplicantSeq: data.ApplicantDtls[i].ApplicantSeq,
                            Designation: helper.getDesignationbyIDNum(data.ApplicantDtls[i].IDNum,holders),
                            SelectedValue: true
                        })
                    }
                }
            }
        }
        certPersonsArray.sort(function(certPerA, certPerB){return parseInt(certPerA.ApplicantSeq)-parseInt(certPerB.ApplicantSeq)});
 
        setCertPersons(certPersonsArray);
    }

    const bindApptPersonsFromApplicantDtls = (data) => {
        let apptAuthPersonsArray = [];
        if(data.ApplicantDtls.length === undefined) {
            apptAuthPersonsArray.push({
                Name: data.ApplicantDtls.Name,
                IDNum: data.ApplicantDtls.IDNum,
                ApplicantSeq: data.ApplicantDtls.ApplicantSeq,
                Designation:helper.getDesignationbyIDNum(data.ApplicantDtls.IDNum,holders),
                SelectedValue: true
            })
        }
        else {
            for(let i in data.ApplicantDtls) {
                if(data.ApplicantDtls[i].ApplicantSeq !== seq0) {
                    if(data.ApplicantDtls[i].Authorised === undefined || data.ApplicantDtls[i].Authorised === 'true'){
                        apptAuthPersonsArray.push({
                            Name: data.ApplicantDtls[i].Name,
                            IDNum: data.ApplicantDtls[i].IDNum,
                            ApplicantSeq: data.ApplicantDtls[i].ApplicantSeq,
                            Designation:helper.getDesignationbyIDNum(data.ApplicantDtls[i].IDNum,holders),
                            SelectedValue: true
                        })
                    }
                }
            }
        }

        apptAuthPersonsArray.sort(function(authPerA, authPerB){return parseInt(authPerA.ApplicantSeq)-parseInt(authPerB.ApplicantSeq)});
        setAuthPersons(apptAuthPersonsArray);
    }
 
    const getBindBoardResoClare = (data) => {
 
        if(getLoginUserOrder(data) === seq0) {
            return data.BoadResoClare.AuthPerSeq0;
        }
        if(getLoginUserOrder(data) === seq1) {
            return data.BoadResoClare.AuthPerSeq1;
        }
        if(getLoginUserOrder(data) === seq2) {
            return data.BoadResoClare.AuthPerSeq2;
        }
        if(getLoginUserOrder(data) === seq3) {
            return data.BoadResoClare.AuthPerSeq3;
        }
        
    }

    const bindConOfSigns = (data) => {
      
        if(data.SignConditionAP && data.SignConditionAP !==null){
            setNSDeleDtls({
                SignConditionAP: helper.getObjInArray(data.SignConditionAP,conOfSigns),
                BoadResoClare:getBindBoardResoClare(data) === 'true'? true:false
            })

            setBoardResoClare({
                AuthPerSeq0:data.BoadResoClare.AuthPerSeq0 === 'true'? true:false,
                AuthPerSeq1:data.BoadResoClare.AuthPerSeq1 === 'true'? true:false,
                AuthPerSeq2:data.BoadResoClare.AuthPerSeq2 === 'true'? true:false,
                AuthPerSeq3:data.BoadResoClare.AuthPerSeq3 === 'true'? true:false
            })
        }

        //As YW requested on ROF 88, not auto display
        /*
        if(data.ApplicantDtls.length === undefined ||data.ApplicantDtls.length === 1) {
            conOfSigns.length = 1;
            setNSDeleDtls({
                SignConditionAP: helper.getObjInArray('1',conOfSigns),
                BoadResoClare:true
            })
        } 
        else {
            conOfSigns.length = data.ApplicantDtls.length;
            if(conOfSigns.length === 2){
                setNSDeleDtls({
                    SignConditionAP: helper.getObjInArray('2',conOfSigns),
                    BoadResoClare:true
                })
            }
            else if(conOfSigns.length === 3) {
                setNSDeleDtls({
                    SignConditionAP: helper.getObjInArray('3',conOfSigns),
                    BoadResoClare:true
                })
            }
        }
        */
    }

    const createHolders = (data) => {
        let temp = [];
        let myInfoAppDtls = {
            IDNum:data.ApplicantsDtlsMyInfo.IDNum,
            Name:data.ApplicantsDtlsMyInfo.Name,
            Designation:data.ApplicantsDtlsMyInfo.Designation !==null? data.ApplicantsDtlsMyInfo.Designation:'',
            Nationality:data.ApplicantsDtlsMyInfo.Nationality !==null? data.ApplicantsDtlsMyInfo.Nationality:''
        }

        if(!Array.isArray(data.Holdersdetails)) {
            // temp.push(myInfoAppDtls); //no need to add login user
            if(data.Holdersdetails.IDNum !== null && data.Holdersdetails.Name !== null) {
                temp.push(data.Holdersdetails);
                holders = temp;
            }
        }
        else {
            // temp.push(myInfoAppDtls); //no need to add login user
            for(let i in data.Holdersdetails) {
                if(data.Holdersdetails[i].IDNum !== null && data.Holdersdetails[i].Name !== null){
                    temp.push(data.Holdersdetails[i]);
                }
            }
            holders = temp;
        }
    }

    const handleSubmit = (eve) => {
  
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
        if(helper.isInvalidState()) {
            window.location.href = config.link.Cancle;
            return;
        }

        if(eve.isValid){
            let data = JSON.parse(JSON.stringify(eve.values));
            if(validate(data)){
                saveDeleDetails(formatJsonParams(data));
            }
        }
    }

    const validate = (data) => {
        let valid = true;
 
        if(data.SignConditionAP === null || data.SignConditionAP.value === undefined) {
            showErrMsg(config.error.DelegationDetails.SelectSignCondAP);
            valid= false;
        }
        else if(authPersons.length === 3) {
            if(data.SignConditionAP.value === conOfSigns[2].value ||data.SignConditionAP.value === conOfSigns[1].value||data.SignConditionAP.value === conOfSigns[0].value) {
                valid= true;
            }
        }
        else if(authPersons.length === 2) {
            if(data.SignConditionAP.value === conOfSigns[2].value) {
                showErrMsg(config.error.DelegationDetails.Select2AP);
                valid= false;
            }
            else {
                valid = true;
            }
        }
        else if(authPersons.length === 1) {
            if(data.SignConditionAP.value === conOfSigns[2].value || data.SignConditionAP.value === conOfSigns[1].value) {
                showErrMsg(config.error.DelegationDetails.Select1AP);
                valid= false;
            }
            else {
                valid = true;
            }
        }

        return valid;
    }

    const saveDeleDetails = (params) =>{
        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess) {
                
                goNext();
            }
            else {
                showErrMsg(config.error.SaveApiFailed);
            }    
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }

    const goNext = () => {
        if(history.location.state !== undefined) {
            if(history.location.state.from === config.route.Preview) {
                history.goBack();
            }
        }
        else {
            if(isFirstUser()){
                history.push(config.route.NSDelegationDetails2);
            }
            else { //not first user, subsequent login users
                routeUploadDtlsbyType();
            }
        }
    }

    const routeUploadDtlsbyType = () => {
        let uploadDtlsType = storage.getCompType();
        if(uploadDtlsType === uploadConfig.SCOType.SCO2) {
            history.push(config.route.LLPUploadDetails);
        }
        else if(uploadDtlsType === uploadConfig.SCOType.SCO3) {
            history.push(config.route.ACSUploadDetails);
        }
        else {  // SCO1, SCO4
            history.push(config.route.NSUploadDetails);
        }
    }

    let formatJsonParams = function(data) {
        let params = {
            SignConditionAP:data.SignConditionAP.value,   
            ApptAuthPerson:authPersons,
            BoardResolutions:{
                CertifyPerson:certPersons
            },
            BoadResoClare: formatBoadResoClare(data.BoadResoClare)
        }
        return params;
    }

    const formatBoadResoClare = (value) => {
        let params = {
            AuthPerSeq0:getLoginUserOrder(response) === seq0? value:boardResoClare.AuthPerSeq0,
            AuthPerSeq1:getLoginUserOrder(response) === seq1? value:boardResoClare.AuthPerSeq1,
            AuthPerSeq2:getLoginUserOrder(response) === seq2? value:boardResoClare.AuthPerSeq2,
            AuthPerSeq3:getLoginUserOrder(response) === seq3? value:boardResoClare.AuthPerSeq3
        };

        return params;
    }

    let formatCertPersons = () => {
        let certPerArray= [];
        for(let i in certPersons) {
            certPerArray.push({
                NRIC:certPersons[i].IDNum,
                Name: certPersons[i].Name,
                Designation:certPersons[i].Designation,
                SelectedValue:certPersons[i].SelectedValue
            })
        }

        return certPerArray;
    }

    let formatAuthPersons = () => {
        let authPerArray= [];
        for(let i in authPersons) {
            authPerArray.push({
                NRIC:authPersons[i].IDNum,
                Name:authPersons[i].Name,
                Designation:authPersons[i].Designation,
                SelectedValue:authPersons[i].SelectedValue
            })
        }

        return authPerArray;
    }

    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }

    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }

    const getDesignationLabel = (code) => {
        if(code !== undefined && code !==null && code !== '') {
            return helper.getObjInArray(code,designations).label;
        }
        return '';
    }

    const disalbeNextBtn = () => {
      //  console.log('nsDeleDtls.CertifyBR',nsDeleDtls.BoadResoClare)
        if(nsDeleDtls.BoadResoClare){
            return false;
        }
        else {
            return true;
        }
    }

    const getLoginUserOrder = (resObj) => {
        let authSeq = '', isAuthPerson = false;
        if(!Array.isArray(resObj.ApplicantDtls)){ //check obj or array
            if(resObj.ApplicantDtls.IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum){
                authSeq = resObj.ApplicantDtls.ApplicantSeq;
                isAuthPerson = true;
            }
            else {  //non login user
                authSeq = '0';
                isAuthPerson = false;
            }
        }
        else { //array
            for(let i in resObj.ApplicantDtls) {
                if(resObj.ApplicantDtls[i].IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum) {  // get login user's seq number 
                    authSeq = resObj.ApplicantDtls[i].ApplicantSeq;
                    isAuthPerson = true;
                }
            }
        }

        if(isAuthPerson){
            return authSeq;
        }
        else {
            return '0';
        }
    }

    const handleCancel = (e) => { 
        e.preventDefault(); 
        if(isFirstUser()){
            history.push(config.route.NSBizBankingService)
        }
        else {
            history.push(config.route.NSApplicantDetails)
        }
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return(
        <div className="container-fluid">
            <SubHeader />
            <FormContainer>
                <Form  
                    onSubmitClick={handleSubmit} 
                    initialValues={nsDeleDtls}
                    key={JSON.stringify(nsDeleDtls)}
                    render={(formRenderProps) => (
                    <FormElement>
                    <fieldset>
                        <Field component={FormTitle} id={'fst1'} name={delegateData.formContainerTitle.NST1.name} />

                        <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />

                        <Field component={FormSubTitle} id={'fstNSST1'} name={delegateData.formSubTitle.NSST1} />
                        <Field component={FormSubTitleDesp} id={'fstNSSTD3'} name={delegateData.formSubTitleDesp.NSSTD1} />
                        <Field component={FormSubTitleDesp} id={'fstNSSTD3'} name={delegateData.formSubTitleDesp.NSSTD1Note} />

                        {certPersons.map((item, idx) => (
                            <WtBgChkbox key={idx} id={item.IDNum} label={item.Name} rightLabel={getDesignationLabel(item.Designation)}
                                checkedValue={item.SelectedValue}
                                disabled={true}
                                onCheckedChange={(v,id)=>{
                                    certPersons[idx].SelectedValue = v;
                                }} />))}

                        <FieldWrapper><div className="row" style={{borderBottom:'2px solid #FFC83D'}} /> </FieldWrapper>
                        <Field component={FormSubTitle} id={'fstNSST2'} name={delegateData.formSubTitle.NSST2} />
                        <Field component={FormSubTitleDesp} id={'fstNSSTD2'} name={delegateData.formSubTitleDesp.NSSTD2} />

                        <div className="row around-xs inputPair elementVisible">
                        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                        <label className="box" id={'lbl'} style={{fontSize:'14px'}}>{delegateData.boardReso.firstlbl}
                        <a className="txtBlue" target="_blank" href={helper.getPdfUrl('Board_Resolution.pdf')} >{delegateData.boardReso.ahref.lbl}</a>
                            {delegateData.boardReso.seclbl} <b>{getCompName()}</b> {delegateData.boardReso.thirdlbl}
                        </label>
                        </div></div>

                        <div className="row" style={{borderBottom:'2px solid #FFC83D',paddingTop:'10px'}} />
                        <Field component={FormSubTitle} id={'fstNSST3'} name={delegateData.formSubTitle.NSST3} />
                        <Field component={FormSubTitleDesp} id={'fstNSSTD3'} name={delegateData.formSubTitleDesp.NSSTD3} />
                    
                       
                        <div className="row around-xs inputPair elementVisible">
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <div className="box" id={'lblSignConditionAP'} style={{ marginTop: "5px" }}>
                                    <div style={{width:'94%', float:"left"}}><span>{delegateData.label.nsConOfSign}</span>
                                    </div>
                                    <div style={{width:'6%', float:"left"}}>
                                        <Tooltip id={'ttSignConditionAP'} content={(props) => 
                                            <TooltipTemplate id={'tttSignConditionAP'} title={props.title}/>} 
                                                anchorElement={'target'} position={'right'} >
                                            <span className="k-icon k-i-information" title={delegateData.tooltip.conOfPer}></span> 
                                        </Tooltip>
                                    </div>
                                 </div>
                            </div>
                            <div className="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                <div className="box" style={{ marginTop: "5px" }}>
                                    <Field component={FormComboBox} 
                                        id={'SignConditionAP'} 
                                        name={'SignConditionAP'} 
                                        textField={'label'}  
                                        data={conOfSigns}
                                        placeholder={'Please select'}
                                        disabled={!isFirstUser()}
                                        onChange={e =>{
                                            if(e.value === null){
                                                return;
                                            }
                                        }} />
                                </div> 
                            </div>
                        </div>
                

                        <Field component={FormSubTitle} id={'fstNSST4'} name={delegateData.formSubTitle.NSST4} />
                        <Field component={FormSubTitleDesp} id={'fstNSSTD4'} name={delegateData.formSubTitleDesp.NSSTD4} />

                        {authPersons.map((item, idx) => (
                            <WtBgChkbox key={idx} id={item.IDNum} label={item.Name} rightLabel={getDesignationLabel(item.Designation)}
                                disabled={true}
                                checkedValue={true}
                                onCheckedChange={(v,id)=>{
                                   authPersons[idx].SelectedValue = v;
                                }} />
                          ))}

                       
                        <FieldWrapper style={{paddingTop:'10px'}}>
                        {/* <Field name={'CertifyBR'} label={delegateData.label.terms} id={'certifyBR'}
                            component={TermsFormCheckbox} value={true} /> */}
                        </FieldWrapper>
                        <Field name={'BoadResoClare'} label={delegateData.label.terms} id={'BoadResoClare'}
                            component={TermsFormCheckboxNoErrMsgDisplay} value={true} validator={certBoardResoValidator} />

                        <FieldWrapper>
                        <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} /> 
                        <div className="row around-xs inputPair elementVisible" style={{ paddingBottom: "20px" }}>
                        <div  className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                            <button className="btn btn-back" 
                                onClick={handleCancel}>{config.btnName.Back}</button>
                            <button type={'submit'} className="k-button btn btn-success btn-float-right"  disabled={!formRenderProps.valid} >{config.btnName.Next}</button>
                        </div>
                        </div>
                        </FieldWrapper>

                        {/* {isError && <CusNotification msg={errMsg} closable={true} status={'error'} 
                            onClose={()=>{ setIsError(false)}} />} */}
                        
                            <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} />

                      </fieldset>
                    </FormElement>
                )}>
                </Form>
               
            </FormContainer>
            {isSaving && <Loading />} 
        </div>
    )
}

export default NSDelegationDetails